import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function Footer() {
  return (
    <footer className="py-12 md:py-16 px-4 md:px-6 bg-background-200">
      <div className="max-w-7xl mx-auto">
        <div className="bg-background-50 rounded-3xl p-8 md:p-12 relative overflow-hidden">
          <div className="absolute -top-6 -left-6 w-24 h-24 bg-primary-400/10 rounded-full"></div>
          <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-accent-400/10 rounded-full"></div>

          <div className="relative grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-10">
            <div className="md:col-span-4">
              <Link to="/" className="text-2xl font-heading font-bold text-foreground-950 cursor-pointer">
                gtbuy<span className="text-primary-500">.my</span>
              </Link>
              <p className="text-xs md:text-sm text-foreground-500 mt-3 leading-relaxed max-w-xs">
                Your gateway to smarter spreadsheet shopping. Compare prices across GTBuy, Kakobuy, and Superbuy in one organized view. Updated daily with curated deals.
              </p>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-xs font-label font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                CATEGORIES
              </h4>
              <ul className="space-y-2">
                {categories.slice(0, 7).map((cat) => (
                  <li key={cat.seq}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-xs md:text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-3">
              <h4 className="text-xs font-label font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                MORE CATEGORIES
              </h4>
              <ul className="space-y-2">
                {categories.slice(7).map((cat) => (
                  <li key={cat.seq}>
                    <a
                      href={cat.url}
                      target="_blank"
                      rel="noopener nofollow"
                      className="text-xs md:text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                    >
                      {cat.name}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            <div className="md:col-span-2">
              <h4 className="text-xs font-label font-semibold text-foreground-400 uppercase tracking-wider mb-4">
                QUICK LINKS
              </h4>
              <ul className="space-y-2">
                <li>
                  <Link
                    to="/blog/gtbuy-spreadsheet-shopping-guide"
                    className="text-xs md:text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    Shopping Guide
                  </Link>
                </li>
                <li>
                  <a
                    href="https://kaspreadsheet.com"
                    target="_blank"
                    rel="noopener nofollow"
                    className="text-xs md:text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    Kaspreadsheet
                  </a>
                </li>
                <li>
                  <Link
                    to="/"
                    className="text-xs md:text-sm text-foreground-600 hover:text-foreground-950 transition-colors cursor-pointer"
                  >
                    Home
                  </Link>
                </li>
              </ul>
            </div>
          </div>

          <div className="relative mt-8 md:mt-10 pt-6 border-t border-background-200 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-foreground-400 font-label">
              &copy; {new Date().getFullYear()} gtbuy.my &mdash; All rights reserved
            </p>
            <div className="flex items-center gap-4">
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center hover:bg-background-300 transition-colors cursor-pointer"
                aria-label="Kaspreadsheet"
              >
                <i className="ri-external-link-line text-foreground-600 text-sm"></i>
              </a>
              <a
                href="https://kaspreadsheet.com"
                target="_blank"
                rel="noopener nofollow"
                className="w-8 h-8 rounded-full bg-background-200 flex items-center justify-center hover:bg-background-300 transition-colors cursor-pointer"
                aria-label="Shop"
              >
                <i className="ri-shopping-bag-line text-foreground-600 text-sm"></i>
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}